/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

		// becuase number inputs don't limit max until submit
		$('input[type="number"]').each(function(){
			$(this).on('keyup',function(){
				if ($(this).val() > Number($(this).attr("max"))) {
          val=$(this).val().slice(0, $(this).attr("max").length);
          $(this).val(val);
        }
			});
		});